module.exports = {
    isLocal(env = process.env.NODE_ENV) {
        if (!env) {
            return false;
        }

        return env.toLowerCase() === 'local';
    },

    isDevelopment(env = process.env.NODE_ENV) {
        if (!env) {
            return false;
        }

        return env.toLowerCase() === 'dev' || env === 'development';
    },

    isStaging(env = process.env.NODE_ENV) {
        if (!env) {
            return false;
        }

        return env.toLowerCase() === 'staging' || env.toLowerCase() === 'sta';
    },

    isProduction(env = process.env.NODE_ENV) {
        if (!env) {
            return false;
        }

        return !(
            this.isLocal(env.toLowerCase()) ||
            this.isDevelopment(env.toLowerCase()) ||
            this.isStaging(env.toLowerCase())
        );
    }
};
